"use client";

import dynamic from "next/dynamic";

// The bot only appears after 10s, so its code loads in a separate chunk after the page
// is interactive instead of competing with the first paint
const ChatBot = dynamic(() => import("./ChatBot"), { ssr: false });

export default function ChatBotLazy() {
  return <ChatBot />;
}
